import { render, staticRenderFns } from "./areaDataAnalysis.vue?vue&type=template&id=bdd190b2&"
import script from "./areaDataAnalysis.vue?vue&type=script&lang=js&"
export * from "./areaDataAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports